import { createRef } from 'react';

import {
  NavigationContainerRef,
  NavigationState,
  PartialState
} from '@react-navigation/native';

export const isReadyRef = createRef();

export const routeNameRef = createRef<string>();
export const navigationRef = createRef<NavigationContainerRef>();

export function navigate(name: string, params?: Record<string, unknown>): void {
  if (isReadyRef.current && navigationRef.current) {
    navigationRef.current.navigate(name, params);
  }
}

export function reset(
  state: PartialState<NavigationState> | NavigationState
): void {
  if (isReadyRef.current && navigationRef.current) {
    navigationRef.current.reset(state);
  }
}
